import { ICleanupDataItem, IEntityInfo, IProductSync } from '@/models/akeneoSync.model';
import { IApiError } from '@/models/apiError.model';

export const SLICE_NAME = 'akeneoSync';

export interface AkeneoSyncState {
  entities: IEntityInfo[] | null;
  productsSync: IProductSync[] | null;
  isLoading: boolean;
  error: IApiError | null;
  cleanupDatabaseData: ICleanupDataItem[] | null;
}

export const initialState: AkeneoSyncState = {
  entities: null,
  productsSync: null,
  isLoading: false,
  error: null,
  cleanupDatabaseData: null,
};
